export const roles = [
  { id: "venue", label: "Venue Manager" },
  { id: "artist", label: "Artist/Management" },
  { id: "organizer", label: "Event Organizer" },
  { id: "promoter", label: "Promoter" },
  { id: "technical", label: "Technical Provider" },
  { id: "legal", label: "Legal Team" },
  { id: "sponsor", label: "Sponsor" },
  { id: "talent", label: "Talent Agency" },
  { id: "media", label: "Media Production" },
  { id: "catering", label: "Catering Service" },
];

export const contractTypes = {
  venue: [
    { id: "venue-rental", label: "Venue Rental Agreement" },
    { id: "performance", label: "Performance Contract" },
    { id: "exclusive-use", label: "Exclusive Use Agreement" },
    { id: "liability-waiver", label: "Liability Waiver" },
  ],
  artist: [
    { id: "artist-performance", label: "Artist Performance Agreement" },
    { id: "rider", label: "Technical Rider" },
    { id: "recording-rights", label: "Recording Rights Agreement" },
    { id: "merchandise", label: "Merchandise Sales Agreement" },
  ],
  organizer: [
    { id: "event-contract", label: "Event Production Contract" },
    { id: "vendor-agreement", label: "Vendor Agreement" },
    { id: "staff-contract", label: "Staff Contract" },
    { id: "insurance-agreement", label: "Insurance Agreement" },
  ],
  promoter: [
    { id: "promotion-contract", label: "Promotion Contract" },
    { id: "revenue-sharing", label: "Revenue Sharing Agreement" },
    { id: "marketing-agreement", label: "Marketing Agreement" },
    { id: "sponsorship-contract", label: "Sponsorship Contract" },
  ],
  technical: [
    { id: "equipment-rental", label: "Equipment Rental Contract" },
    { id: "production-services", label: "Production Services Agreement" },
    { id: "av-services", label: "Audio/Visual Services Contract" },
    { id: "installation-agreement", label: "Installation Agreement" },
  ],
  legal: [
    { id: "custom-agreement", label: "Custom Legal Agreement" },
    { id: "amendment", label: "Contract Amendment" },
    { id: "dispute-resolution", label: "Dispute Resolution Agreement" },
    { id: "confidentiality", label: "Confidentiality Agreement" },
  ],
  sponsor: [
    { id: "sponsorship-agreement", label: "Sponsorship Agreement" },
    { id: "brand-partnership", label: "Brand Partnership Contract" },
    { id: "naming-rights", label: "Naming Rights Agreement" },
    { id: "in-kind-sponsorship", label: "In-Kind Sponsorship Agreement" },
  ],
  talent: [
    { id: "talent-representation", label: "Talent Representation Agreement" },
    { id: "booking-contract", label: "Booking Contract" },
    { id: "exclusivity-agreement", label: "Exclusivity Agreement" },
    { id: "commission-agreement", label: "Commission Agreement" },
  ],
  media: [
    { id: "media-rights", label: "Media Rights Agreement" },
    { id: "broadcast-license", label: "Broadcast License" },
    { id: "content-creation", label: "Content Creation Agreement" },
    { id: "streaming-rights", label: "Streaming Rights Contract" },
  ],
  catering: [
    { id: "catering-services", label: "Catering Services Agreement" },
    { id: "food-beverage", label: "Food & Beverage Contract" },
    { id: "special-dietary", label: "Special Dietary Requirements Agreement" },
    { id: "bar-services", label: "Bar Services Contract" },
  ],
};

export const steps = [
  "role-selection",
  "contract-type",
  "input-collection",
  "json-output"
];

export const wizardLabels = [
  "Select Role",
  "Contract Type",
  "Enter Details",
  "Review"
];

export const getFormFields = (userRole, contractType) => {
  if (userRole === "venue" && contractType === "venue-rental") {
    return [
      { id: "venueName", label: "Venue Name", type: "text" },
      { id: "capacity", label: "Venue Capacity", type: "number" },
      { id: "rentalDate", label: "Rental Date", type: "date" },
      { id: "rentalFee", label: "Rental Fee ($)", type: "number" },
      { id: "depositAmount", label: "Security Deposit ($)", type: "number" },
      { id: "venueAddress", label: "Venue Address", type: "textarea" },
      { id: "servicesIncluded", label: "Services Included", type: "textarea" },
      { id: "setupTime", label: "Setup Time", type: "time" },
      { id: "teardownTime", label: "Teardown Time", type: "time" },
      { id: "insuranceRequirements", label: "Insurance Requirements", type: "textarea" },
    ];
  } else if (userRole === "venue" && contractType === "exclusive-use") {
    return [
      { id: "venueName", label: "Venue Name", type: "text" },
      { id: "clientName", label: "Client Name", type: "text" },
      { id: "exclusiveUseDate", label: "Exclusive Use Date", type: "date" },
      { id: "startTime", label: "Start Time", type: "time" },
      { id: "endTime", label: "End Time", type: "time" },
      { id: "exclusiveFee", label: "Exclusive Use Fee ($)", type: "number" },
      { id: "depositAmount", label: "Deposit Amount ($)", type: "number" },
      { id: "cancellationPolicy", label: "Cancellation Policy", type: "textarea" },
      { id: "specialRequirements", label: "Special Requirements", type: "textarea" },
    ];
  } else if (userRole === "artist" && contractType === "artist-performance") {
    return [
      { id: "artistName", label: "Artist/Band Name", type: "text" },
      { id: "performanceDate", label: "Performance Date", type: "date" },
      { id: "performanceDuration", label: "Performance Duration (minutes)", type: "number" },
      { id: "compensation", label: "Compensation ($)", type: "number" },
      { id: "depositRequired", label: "Deposit Required ($)", type: "number" },
      { id: "technicalRequirements", label: "Technical Requirements", type: "textarea" },
      { id: "soundCheckTime", label: "Sound Check Time", type: "time" },
      { id: "merchandiseSplit", label: "Merchandise Split (%)", type: "number" },
      { id: "hospitalityRequirements", label: "Hospitality Requirements", type: "textarea" },
      { id: "cancellationTerms", label: "Cancellation Terms", type: "textarea" },
    ];
  } else if (userRole === "artist" && contractType === "merchandise") {
    return [
      { id: "artistName", label: "Artist/Band Name", type: "text" },
      { id: "venueName", label: "Venue Name", type: "text" },
      { id: "eventDate", label: "Event Date", type: "date" },
      { id: "merchandiseItems", label: "Merchandise Items", type: "textarea" },
      { id: "venueSplit", label: "Venue Split (%)", type: "number" },
      { id: "artistSplit", label: "Artist Split (%)", type: "number" },
      { id: "salesTaxResponsibility", label: "Sales Tax Responsibility", type: "text" },
      { id: "merchandiseLocation", label: "Merchandise Location", type: "text" },
      { id: "staffingResponsibility", label: "Staffing Responsibility", type: "text" },
    ];
  } else if (userRole === "sponsor" && contractType === "sponsorship-agreement") {
    return [
      { id: "sponsorName", label: "Sponsor Name", type: "text" },
      { id: "eventName", label: "Event Name", type: "text" },
      { id: "sponsorshipLevel", label: "Sponsorship Level", type: "text" },
      { id: "sponsorshipAmount", label: "Sponsorship Amount ($)", type: "number" },
      { id: "sponsorshipDuration", label: "Sponsorship Duration", type: "text" },
      { id: "sponsorBenefits", label: "Sponsor Benefits", type: "textarea" },
      { id: "paymentSchedule", label: "Payment Schedule", type: "textarea" },
      { id: "logoUsageTerms", label: "Logo Usage Terms", type: "textarea" },
      { id: "exclusivityTerms", label: "Exclusivity Terms", type: "textarea" },
    ];
  } else if (userRole === "media" && contractType === "media-rights") {
    return [
      { id: "contentOwner", label: "Content Owner", type: "text" },
      { id: "mediaCompany", label: "Media Company", type: "text" },
      { id: "contentDescription", label: "Content Description", type: "textarea" },
      { id: "rightsGranted", label: "Rights Granted", type: "textarea" },
      { id: "territoryScope", label: "Territory Scope", type: "text" },
      { id: "licenseDuration", label: "License Duration", type: "text" },
      { id: "compensationTerms", label: "Compensation Terms", type: "textarea" },
      { id: "creditRequirements", label: "Credit Requirements", type: "textarea" },
      { id: "approvalProcess", label: "Approval Process", type: "textarea" },
    ];
  } else if (userRole === "catering" && contractType === "catering-services") {
    return [
      { id: "cateringCompany", label: "Catering Company", type: "text" },
      { id: "clientName", label: "Client Name", type: "text" },
      { id: "eventDate", label: "Event Date", type: "date" },
      { id: "eventTime", label: "Event Time", type: "time" },
      { id: "guestCount", label: "Guest Count", type: "number" },
      { id: "menuSelection", label: "Menu Selection", type: "textarea" },
      { id: "pricePerPerson", label: "Price Per Person ($)", type: "number" },
      { id: "serviceStyle", label: "Service Style", type: "text" },
      { id: "beverageOptions", label: "Beverage Options", type: "textarea" },
      { id: "specialDietaryRequirements", label: "Special Dietary Requirements", type: "textarea" },
      { id: "staffingDetails", label: "Staffing Details", type: "textarea" },
      { id: "depositAmount", label: "Deposit Amount ($)", type: "number" },
    ];
  } else {
    return [
      { id: "partyA", label: "First Party Name", type: "text" },
      { id: "partyB", label: "Second Party Name", type: "text" },
      { id: "effectiveDate", label: "Effective Date", type: "date" },
      { id: "termDuration", label: "Term Duration (days)", type: "number" },
      { id: "paymentTerms", label: "Payment Terms", type: "textarea" },
      { id: "additionalTerms", label: "Additional Terms", type: "textarea" },
      { id: "terminationClause", label: "Termination Clause", type: "textarea" },
      { id: "governingLaw", label: "Governing Law", type: "text" },
      { id: "disputeResolution", label: "Dispute Resolution", type: "textarea" },
    ];
  }
};

export const supportedLanguages = [
  { id: "en", label: "English" },
  { id: "es", label: "Spanish" },
  { id: "fr", label: "French" },
  { id: "de", label: "German" },
  { id: "it", label: "Italian" },
  { id: "sr", label: "Serbian" },
  { id: "pt", label: "Portuguese" },
  { id: "nl", label: "Dutch" },
  { id: "ru", label: "Russian" },
  { id: "tr", label: "Turkish" },
  { id: "ro", label: "Romanian" }
]; 